"use strict";
/**
 * Shared length limits, regex patterns, and error labels for validating
 * user-chosen custom display names, used by both client-side form validation
 * and server-side `validateNameAsync`.
 *
 * The default rule is intentionally restrictive (lowercase ASCII letters and
 * digits, no separators) because most public deployments want predictable,
 * low-ambiguity handles. Silos with their own rule (SRG, CBC/RC) are chosen by
 * silo key in `getCustomNameValidation`; the SRG rule additionally allows
 * uppercase letters, the Latin-1 accented range (`À-ÖØ-öø-ÿ`, which excludes
 * the multiplication and division signs at U+00D7 / U+00F7), single spaces and
 * single hyphens between word characters — but never as leading, trailing, or
 * consecutive separators.
 *
 * Client and server both read the rules from here: divergence would silently
 * let a client-accepted name be rejected by the server (or vice-versa). This
 * file must not import Node-only or browser-only modules; it is consumed by
 * both the React/Expo client and the Node.js server.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CBC_RC_CUSTOM_NAME_REGEX = exports.SRG_CUSTOM_NAME_REGEX = exports.DEFAULT_CUSTOM_NAME_REGEX = exports.CUSTOM_NAME_MAX_LENGTH = exports.CUSTOM_NAME_MIN_LENGTH = void 0;
exports.getCustomNameValidation = getCustomNameValidation;
const label_1 = require("./translations/label");
exports.CUSTOM_NAME_MIN_LENGTH = 3;
exports.CUSTOM_NAME_MAX_LENGTH = 50;
exports.DEFAULT_CUSTOM_NAME_REGEX = /^[a-z0-9]+$/;
exports.SRG_CUSTOM_NAME_REGEX = /^[a-zA-ZÀ-ÖØ-öø-ÿ0-9]+([ -][a-zA-ZÀ-ÖØ-öø-ÿ0-9]+)*$/;
exports.CBC_RC_CUSTOM_NAME_REGEX = /^[a-zA-ZàâäéèêëîïôöùûüçÀÂÄÉÈÊËÎÏÔÖÙÛÜÇ]+(?:['’ -][a-zA-ZàâäéèêëîïôöùûüçÀÂÄÉÈÊËÎÏÔÖÙÛÜÇ]+)*$/;
function getCustomNameValidation(siloKey) {
    switch (siloKey) {
        case 'srg':
            return {
                regex: exports.SRG_CUSTOM_NAME_REGEX,
                errorLabel: (0, label_1.t)('srg.profile.error_name_invalid', 'Custom names can only include letters, numbers, spaces and hyphens.'),
            };
        case 'cbc':
        case 'cbcInt':
        case 'rc':
        case 'rcInt':
            return {
                regex: exports.CBC_RC_CUSTOM_NAME_REGEX,
                errorLabel: (0, label_1.t)('cbc_rc.profile.error_name_invalid', 'Include only letters, apostrophes, hyphens and no repeated spaces. Maximum of 50 characters.'),
            };
        default:
            return {
                regex: exports.DEFAULT_CUSTOM_NAME_REGEX,
                errorLabel: (0, label_1.t)('profile.error_name_invalid', 'Custom names can only include lowercase letters and numbers.'),
            };
    }
}
//# sourceMappingURL=name-validation.js.map